// export const BASE_URL_LOGIN = "http://demoapi.nardi.info/api/";
// export const BASE_URL = "http://demoapi.nardi.info/api/Dashboard";
// export const BASE_URL_IMAGE = "http://demoapi.nardi.info";
// export const BASE_URL_IMAGE_Product = "http://demoapi.nardi.info/";
export const BASE_URL_LOGIN = "http://demoapi.nardi.info/api/";
export const BASE_URL = "http://demoapi.nardi.info/api/Dashboard";
export const BASE_URL_IMAGE = "http://demoapi.nardi.info";
export const BASE_URL_IMAGE_Product = "http://demoapi.nardi.info/";
//https://testapi.aiwagroup.org
